import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import { Box, Button, CircularProgress, TextField } from "@mui/material";
import Modal from "Components/Common/Modal";
import { usePostUtilityIssueMutation } from "apis/UtilityIssue";

const AddNewUtilityIssue = ({ isOpen, handleClose, newUtilityData, t }) => {
  const [addUtilityIssue, { isLoading }] = usePostUtilityIssueMutation();
  const [editedUtilityData, setEditedUtilityData] = useState(newUtilityData);

  const addNewIssue = async () => {
    try {
      await addUtilityIssue(editedUtilityData);
      handleClose();
    } catch (err) {}
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Edit Description"
      maxWidth="md"
    >
      <>
        <TextField
          className="w-100 mt-4"
          defaultValue={editedUtilityData?.name}
          placeholder={t("Please Enter Description") + "*"}
          onChange={(e) =>
            setEditedUtilityData((prevState) => ({
              ...prevState,
              name: e.target.value,
            }))
          }
          multiline
          minRows={5}
          maxRows={10}
        />
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            size="small"
            type="submit"
            disabled={isLoading || !editedUtilityData?.name}
            onClick={addNewIssue}
          >
            {t("Submit")}
            {isLoading && <CircularProgress size={20} />}
          </Button>
        </Box>
      </>
    </Modal>
  );
};

AddNewUtilityIssue.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  newUtilityData: PropTypes.object,
  t: PropTypes.func,
};
export default withTranslation()(AddNewUtilityIssue);
